export const electronicSignaturesProcessSteps = [
   {
      icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_Firma+electronica.svg)",
      title: "Cargue su documento o contrato a firmar",
      description: "Suba el archivo que desea firmar a nuestra plataforma.",
   },
   {
      icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_Firma+electronica+2.svg)",
      title: "Capture los detalles del contrato",
      description:
         "Ingrese la información relevante del contrato para facilitar el seguimiento de los derechos y obligaciones establecidas.",
   },
   {
      icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_Firma+electronica+3.svg)",
      title: "Configure a los firmantes",
      description:
         "Ingrese el nombre completo, correo electrónico y número de teléfono de cada firmante vinculado al documento.",
   },
   {
      icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_Firma+electronica+4.svg)",
      title: "Envíe el documento a firmar",
      description:
         "Automatice el seguimiento de las firmas, programando una notificación para cada firmante pendiente.",
   },
   {
      icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_Firma+electronica+5.svg)",
      title: "Gestione sus documentos firmados",
      description:
         "Una vez firmado, el documento o contrato aparecerá en su sección de contratos con los certificados de firma digital correspondientes.",
   },
];
